import 'react-loading-skeleton/dist/skeleton.css'
import React, { FC, useEffect, useState } from 'react'
import Skeleton from 'react-loading-skeleton'
import styled from 'styled-components'
import useColumns from '../../../hooks/useColumns'
import useSchedules from '../../../hooks/useSchedules'
import Flex from '../../Utility/Flex'
import Spacer from '../../Utility/Spacer'
import DropZoneTimeTable from './DropZoneTimeTable'
import Schedule from './Schedule'
import TimetableFlame from './TimetableFlame'
import TimetableHeader from './TimetableHeader'

const DateTimetable: FC = () => {
  const { isLoading: isLoadingSchedules, schedules } = useSchedules()
  const { isLoading } = useColumns()
  const [isFirstLoading, setIsFirstLoading] = useState(true)

  useEffect(() => {
    if (isFirstLoading && !isLoading && !isLoadingSchedules) {
      setIsFirstLoading(false)
    }
  }, [isLoadingSchedules, isLoading])

  return (
    <TimetableFlame>
      {/* 初回のデータ取得時のみスケルトンを表示する */}
      {isFirstLoading ? (
        <>
          <Flex>
            <Spacer width={80.5} height={63}></Spacer>
            <div style={{ flex: 1 }}>
              <Skeleton baseColor="#D3D3D3" height={63} />
            </div>
          </Flex>
          <Flex>
            <Spacer width={80.5} height={480}></Spacer>
            <div style={{ flex: 1 }}>
              <Skeleton
                baseColor="#D3D3D3"
                height={400}
                style={{ flex: 1, marginTop: 180, minWidth: 145 }}
              />
            </div>
            <Spacer width={1} height={480}></Spacer>
            <div style={{ flex: 1 }}>
              <Skeleton
                baseColor="#D3D3D3"
                height={50}
                style={{ flex: 1, marginTop: 100, minWidth: 145 }}
              />
              <Skeleton
                baseColor="#D3D3D3"
                height={50}
                style={{ flex: 1, marginTop: 100, minWidth: 145 }}
              />
              <Skeleton
                baseColor="#D3D3D3"
                height={250}
                style={{ flex: 1, marginTop: 150, minWidth: 145 }}
              />
            </div>
            <Spacer width={1} height={480}></Spacer>
            <div style={{ flex: 1 }}>
              <Skeleton
                baseColor="#D3D3D3"
                height={50}
                style={{ flex: 1, marginTop: 200, minWidth: 145 }}
              />
              <Skeleton
                baseColor="#D3D3D3"
                height={250}
                style={{ flex: 1, marginTop: 50, minWidth: 145 }}
              />
            </div>
            <Spacer width={1} height={480}></Spacer>
            <div style={{ flex: 1 }}>
              <Skeleton
                baseColor="#D3D3D3"
                height={150}
                style={{ flex: 1, marginTop: 100, minWidth: 145 }}
              />
              <Skeleton
                baseColor="#D3D3D3"
                height={200}
                style={{ flex: 1, marginTop: 200, minWidth: 145 }}
              />
            </div>
            <Spacer width={1} height={480}></Spacer>
            <div style={{ flex: 1 }}>
              <Skeleton
                baseColor="#D3D3D3"
                height={150}
                style={{ flex: 1, marginTop: 200, minWidth: 145 }}
              />
              <Skeleton
                baseColor="#D3D3D3"
                height={50}
                style={{ flex: 1, marginTop: 50, minWidth: 145 }}
              />
            </div>
          </Flex>
        </>
      ) : (
        <></>
      )}
      <div style={{ opacity: isFirstLoading ? 0 : isLoadingSchedules ? 0.5 : 1 }}>
        <TimetableHeader />
        <DataView id="dataView">
          <div>
            {isLoading ? (
              <></>
            ) : (
              schedules?.map((schedule) => {
                return <Schedule key={schedule.id} {...schedule} minutes={15} />
              })
            )}
          </div>
          {isLoading ? <></> : <DropZoneTimeTable />}
        </DataView>
      </div>
    </TimetableFlame>
  )
}

export default DateTimetable

const DataView = styled.div`
  /* ここを基準にスケジュールの位置を設定 */
  position: relative;
  width: calc(100% - 80.5px);
  margin-left: 80.5px;
  flex: 1;
`
